<form [formGroup]="docAssignmentsFG">
    <cb-table class="assignment-table cb-margin-top cb-margin-bottom flex" [stringColumns]="displayedColumns" [loaded]="true">
        <tbody cbTableBody formArrayName="assignments">
            @for (row of docAssignments; track row; let i = $index) {
                <tr [formGroupName]="i" class="assignment-row">
                    <td>{{ row.get('sourceLotNumber')?.value }}</td>
                    <td>{{ row.get('sourceJobNumber')?.value }}</td>
                    <td>{{ row.get('documentName')?.value }}</td>
                    <td class="assignment-cell">
                        <mat-form-field appearance="outline" class="assignment-field">
                            <mat-label>Destination Lot #</mat-label>
                            <mat-select formControlName="destinationLotNumber" required>
                                <mat-option [value]="null">- Select -</mat-option>
                                @for (lotNumber of lotNumbers; track lotNumber) {
                                    <mat-option [value]="lotNumber">
                                        {{ lotNumber }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        @if (row.get('destinationLotNumber')?.hasError('required')) {
                            <mat-error>
                                Destination Lot is required
                            </mat-error>
                        }
                    </td>
                </tr>
            } @empty {
                <tr>
                    <td colspan="4">
                        <cb-info-message
                            message="No documents selected yet."
                            icon="info_circle"
                            iconClass="cb-accent"
                        ></cb-info-message>
                    </td>
                </tr>
            }
        </tbody>
    </cb-table>
</form>
